/* eslint-disable @typescript-eslint/no-explicit-any */
import { init, captureException } from '@sentry/browser';
import { ScopeContext } from '@sentry/types';

import {Domain, Realm, Stage} from '@zooplus/commons-lang';

import { ENV } from '../../reward-shop/environment';

let initialized = false;

export const initializeSentry = ({
  realm,
  domain,
  dsn,
  stage,
  version,
}: {
  realm: Realm;
  domain: Domain;
  dsn: string;
  stage: Stage;
  version: string;
}) => {
  if (!initialized && typeof window !== 'undefined') {
    const params = {
      dsn,
      environment: stage,
      release: version,
      initialScope: { tags: { realm, domain } },
    };
    try {
      init(params);
      ENV.isDev && console.log('Sentry configured with', params);
      initialized = true;
    } catch (error) {
      ENV.isDev && console.error(error);
    }
  }
};

const captureErrorInSentry = (error: any, scopeContext?: Partial<ScopeContext>) => {
  ENV.isDev && console.log('Sentry capture', { initialized, error, scopeContext });
  if (initialized) {
    const { tags, ...context } = scopeContext || {};
    captureException(error, {
      ...context,
      // Prevent different errors from being merged in Sentry
      fingerprint: ['{{default}}', String(error?.message)],
      tags: {
        ...tags,
        application: 'appshell',
        path: window.location.pathname,
      },
    });
  }
};

export const logError = (error: any, action?: string) => {
  ENV.isDev && action && console.error(`Failed to ${action} - `, error);
  ENV.isDev && !action && console.error(error);
  captureErrorInSentry(error, {
    contexts: action ? { action: { name: action } } : {},
    // tags: { foo : bar }, // FYI Uncomment if you want to add specific tags for your package
  });
};

export const handleError = async <T>(action: () => T) => {
  try {
    const result = await action();
    return result;
  } catch (error) {
    logError({ error, action: action.name });
  }
  return undefined;
};
